import React from 'react';
import {withRouter} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import AgentPreview from './AgentPreview';
import {Icon, IconTypes} from '../Buttons';
import Spinner from '../Spinner';
import styles from './style.css';

const AgentsList = withRouter(inject('store', 'localizationStore')(observer(
    ({store, localizationStore, onAddAgent, history, location, container}) => {
        const agents = store.agents;
        const selectedAgent = parseInt(location.pathname.split('/')[2], 10);
        const mapFunction = a => <AgentPreview onClick={() => history.push(`/agents/${a.id}`)} agentId={a.id} key={a.id} selected={a.id === selectedAgent} />;
        const emptyListFallback = store.agentsFetching
          ? <Spinner />
          : <span>{localizationStore.locale.empty_agents_list}</span>;
        const footer = <Icon disabled={store.existsAgentWithIdOfCurrentUser()} type={IconTypes.add} style={styles.addAgent} iconStyle={styles.addIcon} onClick={onAddAgent} />;

        return React.createElement(container, {items: agents, mapFunction, emptyListFallback, footer})
})));

export default AgentsList;


// WEBPACK FOOTER //
// ./src/components/AgentsList/index.js